import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import getters from './getters'

Vue.use(Vuex)

//sdsfgg更换即可
const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission
  },
	getters
//	getters: {
//		roles: function(){
//			return []
//		}
//	}
})

export default store
